export default __webpack_public_path__ + "1.18.20/static/media/libreView-ar.3cf809db.svg";